export default __webpack_public_path__ + "static/media/Resume2-page-001.53dd631e.jpg";